var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopilotAiLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "copilot_ai_logo_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "var(--goto-badge-color-red)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "var(--goto-badge-color-violet)"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#copilot_ai_logo_svg__a)",
  fillRule: "evenodd",
  d: "M22 19h-9.714L6 22v-3H2V4h10v2H4v11h4v1.83L11.833 17H20v-7h2z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#copilot_ai_logo_svg__a)",
  d: "m16 6 1-4 1 4 4 1-4 1-1 4-1-4-4-1zM10.6 8.6 11 7l.4 1.6L13 9l-1.6.4L11 11l-.4-1.6L9 9zM13.4 12.4 14 10l.6 2.4 2.4.6-2.4.6L14 16l-.6-2.4L11 13z"
})));
export default SvgCopilotAiLogo;